import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import { mapActions } from 'vuex';
import utils from '@/utils';
import table from '@/mixins/crud-table.js';
export default {
  mixins: [table],
  components: {
    componentForm: function componentForm() {
      return import('./form');
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var page = h("d2-container", {
      "attrs": {
        "spacious": true
      }
    }, [h("d2-search-panel", {
      "slot": "header",
      "model": {
        value: _this.search.panel.active,
        callback: function callback($$v) {
          _this.$set(_this.search.panel, "active", $$v);
        }
      }
    }, [h("d2-bar", {
      "slot": "title"
    }, [h("d2-bar-space"), this.p('query') ? h("d2-bar-cell", [this.vNodePaginationMini]) : h("d2-bar-cell", [this.vNodeSearchPanelAlertNoPermissionQuery]), h("d2-bar-space"), h("d2-bar-cell", [h("el-button-group", [this.p('query') ? this.vNodeButtonSearch : null, this.vNodeButtonTableColumnsFilterTrigger])]), this.p('add') ? h("d2-bar-cell", [this.vNodeButtonCreate]) : null]), this.p('query') ? this.vNodeSearchForm : null]), this.vNodeTable, h("d2-bar", {
      "slot": "footer"
    }, [h("d2-bar-cell", [this.vNodePaginationFull]), h("d2-bar-space")]), h("component-form", {
      "ref": "form",
      "on": {
        "success": this.research
      }
    }), this.vNodeTableColumnsFilter]);
    return page;
  },
  data: function data() {
    return {
      api: {
        index: 'MARKET_ADMIN_ALL',
        delete: 'MARKET_ADMIN_DELETE',
        sync: 'MARKET_ADMIN_SYNC'
      },
      permission: {
        query: '',
        add: 'market:admin:add',
        edit: 'market:admin:edit',
        detail: '',
        remove: 'market:admin:remove',
        sms_recharge: 'sms-recharge',
        market_admin_device: 'market-admin-device',
        market_admin_log: 'market-admin-log'
      }
    };
  },
  computed: {
    // 配置项
    // 表格列
    // 建议的书写顺序 [prop] -> [label] -> [align] -> [minWidth][width] -> [fixed] -> [other] -> [render][formatter] -> [if][show]
    settingColumns: function settingColumns() {
      return [{
        prop: 'id',
        label: this.$t('id'),
        minWidth: '100px'
      }, {
        prop: 'market_id',
        label: this.$t('market_id'),
        minWidth: '100px'
      }, {
        prop: 'admin_account',
        label: this.$t('admin_account'),
        minWidth: '100px'
      }, {
        prop: 'admin_pwd',
        label: this.$t('admin_pwd'),
        minWidth: '100px'
      }, // { prop: 'is_del', label: 'is_del', minWidth: '100px' },
      {
        prop: 'ctime',
        label: this.$t('ctime'),
        minWidth: '100px',
        formatter: function formatter(row) {
          return utils.time.format1(row.ctime, 'YYYY/M/D HH:mm:ss');
        }
      }, {
        prop: 'uptime',
        label: this.$t('uptime'),
        minWidth: '100px',
        formatter: function formatter(row) {
          return utils.time.format1(row.uptime, 'YYYY/M/D HH:mm:ss');
        }
      }].map(function (setting) {
        setting.sortable = 'custom';
        return setting;
      });
    },
    // 配置项
    // 表格操作列配置
    settingActionsConfig: function settingActionsConfig() {
      var _this2 = this;

      return function (_ref) {
        var row = _ref.row;
        return [].concat(_toConsumableArray(_this2.p('market_admin_device', [{
          icon: 'el-icon-collection',
          label: _this2.$t('market-admin-device'),
          action: function action() {
            return _this2.goMarketAdminDevice(row.id);
          }
        }], [])), _toConsumableArray(_this2.p('market_admin_log', [{
          icon: 'el-icon-collection',
          label: _this2.$t('market-admin-log'),
          action: function action() {
            return _this2.goMarketAdminLog(row.id);
          }
        }], [])), _toConsumableArray(_this2.p('remove', [{
          icon: 'el-icon-delete',
          type: 'danger',
          confirm: _this2.$t('confirm_delete_info'),
          action: function action() {
            return _this2.delete(row.id);
          }
        }], [])));
      };
    },
    // 配置项
    // 表格搜索条件
    // 建议的书写顺序 [prop] -> [label] -> [default] -> [render] -> [if][show]
    settingSearch: function settingSearch() {
      var _this3 = this;

      var h = this.$createElement;
      return [{
        prop: 'market_id',
        label: this.$t('market_id'),
        default: utils.cookies.get('market_id'),
        show: false,
        render: function render() {
          return h("el-input", {
            "style": "width:120px;",
            "model": {
              value: _this3.search.form.model.market_id,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "market_id", $$v);
              }
            }
          });
        } // render: () => <d2-dict-select name="search_market_id" vModel={ this.search.form.model.market_id } style="width:140px;" custom clearable/>

      }, {
        prop: 'market_mobile',
        label: this.$t('market_mobile'),
        default: utils.cookies.get('phone'),
        show: false,
        render: function render() {
          return h("el-input", {
            "style": "width:120px;",
            "attrs": {
              "disabled": true
            },
            "model": {
              value: _this3.search.form.model.market_mobile,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "market_mobile", $$v);
              }
            }
          });
        }
      }, {
        prop: 'start_time',
        label: this.$t('start_time'),
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "start_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this3.search.form.model.start_time,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "start_time", $$v);
              }
            }
          });
        }
      }, {
        prop: 'end_time',
        label: this.$t('end_time'),
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "end_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this3.search.form.model.end_time,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "end_time", $$v);
              }
            }
          });
        }
      }];
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/page', ['closeBy'])), {}, {
    goAdminData: function goAdminData(market_id) {
      this.closeBy(function (page) {
        return page.name === 'management-courier-user';
      });
      this.$router.push({
        name: 'management-courier-user',
        query: {
          market_id: market_id
        }
      });
    },
    goDeviceData: function goDeviceData(market_mobile) {
      this.closeBy(function (page) {
        return page.name === 'management-device';
      });
      this.$router.push({
        name: 'management-device',
        query: {
          market_mobile: market_mobile
        }
      });
    },
    goChargeConfigsData: function goChargeConfigsData(market_id) {
      this.closeBy(function (page) {
        return page.name === 'management-charge-configs';
      });
      this.$router.push({
        name: 'management-charge-configs',
        query: {
          market_id: market_id
        }
      });
    },
    goMarketServiceConfigData: function goMarketServiceConfigData(market_mobile) {
      this.closeBy(function (page) {
        return page.name === 'management-market-service-config';
      });
      this.$router.push({
        name: 'management-market-service-config',
        query: {
          market_mobile: market_mobile
        }
      });
    },
    goRechargeConfigData: function goRechargeConfigData(market_id) {
      this.closeBy(function (page) {
        return page.name === 'management-wash-recharge-config';
      });
      this.$router.push({
        name: 'management-wash-recharge-config',
        query: {
          market_id: market_id
        }
      });
    },
    goAppointTimeData: function goAppointTimeData(market_id) {
      this.closeBy(function (page) {
        return page.name === 'management-wash-appoint-time';
      });
      this.$router.push({
        name: 'management-wash-appoint-time',
        query: {
          market_id: market_id
        }
      });
    },
    goMarketAdminDevice: function goMarketAdminDevice(admin_id) {
      this.closeBy(function (page) {
        return page.name === 'management-market-admin-device';
      });
      this.$router.push({
        name: 'management-market-admin-device',
        query: {
          admin_id: admin_id
        }
      });
    },
    goMarketAdminLog: function goMarketAdminLog(admin_id) {
      this.closeBy(function (page) {
        return page.name === 'management-market-admin-log';
      });
      this.$router.push({
        name: 'management-market-admin-log',
        query: {
          admin_id: admin_id
        }
      });
    }
  })
};